import { render } from "./AssetTypeList.vue?vue&type=template&id=504165d4"
import script from "./AssetTypeList.vue?vue&type=script&lang=js"
export * from "./AssetTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/admin/AssetTypeList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "504165d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('504165d4', __exports__)) {
    api.reload('504165d4', __exports__)
  }
  
  module.hot.accept("./AssetTypeList.vue?vue&type=template&id=504165d4", () => {
    api.rerender('504165d4', render)
  })

}


export default __exports__